export default {
	'report-purchase-sell-stock-summary': {
		id: 'report-purchase-sell-stock-summary',
		label: '品项进销存汇总',
		code: '0008_0002'
	}
}
